import { render, staticRenderFns } from "./NoAssiginNode.vue?vue&type=template&id=39bec0fe&"
import script from "./NoAssiginNode.vue?vue&type=script&lang=js&"
export * from "./NoAssiginNode.vue?vue&type=script&lang=js&"
import style0 from "./NoAssiginNode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports